import { GetOppLineItemsResponse } from '@cbinsights/salesforceservice/salesforceservice';
import { UseQueryResult, useQuery } from 'react-query';
import { GetOppLineItems } from '.';
import { getOppLineItems } from '../api/GetOppLineItems';

type Params = Parameters<typeof getOppLineItems>[0];
type Return = GetOppLineItemsResponse;

export const useGetOpLineItemsQuery = ({
  enabled = false,
  params,
}: {
  enabled: boolean;
  params: Params;
}): UseQueryResult<Return, Error> =>
  useQuery<Return, Error, Return, [GetOppLineItems, Params]>(
    ['GetOppLineItems', params],
    () => getOppLineItems(params),
    {
      enabled,
      notifyOnChangeProps: ['data', 'isFetching'],
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: false,
    }
  );
